export const scrollToTopProductList = (selectedFacets, productListRef, deviceType) => {
  const shouldScroll = /sred|isRelatedKeyword|page=|f\.|sortBy|mkid|facetSelected|r\./.test(window.location.href);
  if (shouldScroll) {
    let commentsHeight = productListRef.current.offsetTop;
    if (deviceType === 'mobile') commentsHeight -= 55;
    window.scrollTo({ top: commentsHeight, behavior: 'auto' });
  }
};
